"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormActions = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * Form actions is a simple container for actions associated with a form. The component itself does
 * nothing other than provide layout when nested in a
 * `Form` component.
 *
 * @related [`Form`]
 * @since 8.0.0
 */
var FormActions = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "FormActions",
  componentId: "c11n-8-107-0__sc-1h72c0a-0"
})([""]);
exports.FormActions = FormActions;
FormActions.displayName = 'FormActions';
FormActions.propTypes = {
  /**
   * Specify the type of the container using the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop).
   *
   * By default, this is a `"div"`, but `ButtonGroup`
   * would be appropriate when there are multiple action buttons.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
};
FormActions.defaultProps = {
  as: 'div'
};

/** @component */